(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tmg-project-tools"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tmg-project-tools')) {
    class TMGProjectTools extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.gravel = this.querySelector('[data-gravel]');
        this.fence = this.querySelector('[data-fence]');
        this.gravel.addEventListener('submit', (event) => {
          event.preventDefault();
          const values = this.numbers(this.gravel);
          const area = values.length * values.width;
          const volume = area * values.depth / 1000;
          const total = volume * (1 + values.allowance / 100);
          this.put('[data-area]', area, ' m²');
          this.put('[data-volume]', volume, ' m³');
          this.put('[data-total-volume]', total, ' m³');
          const requiredWeight = total * 1500;
          const pack = this.gravel.elements.pack.selectedOptions[0];
          const packWeight = Number(pack.dataset.packWeight);
          const packCount = Math.ceil(requiredWeight / packWeight - 1e-10);
          this.querySelector('[data-pack-result-label]').textContent = pack.dataset.resultLabel;
          this.put('[data-gravel-result] [data-bags]', packCount);
          this.put('[data-gravel-result] [data-weight]', packCount * packWeight, ' kg');
          this.querySelector('[data-gravel-result]').hidden = false;
        }, options);
        this.gravel.addEventListener('input', () => { this.querySelector('[data-gravel-result]').hidden = true; }, options);
        this.fence.elements.board.addEventListener('change', () => {
          const overlap = this.fence.elements.board.value === '125';
          this.querySelector('[data-gap-label]').hidden = overlap;
          this.querySelector('[data-overlap-label]').hidden = !overlap;
          const spacing = this.fence.elements.spacing;
          spacing.min = overlap ? '1' : '0';
          spacing.max = overlap ? '124' : '1000';
          spacing.value = overlap ? '' : '0';
          this.querySelector('[data-fence-result]').hidden = true;
        }, options);
        this.fence.addEventListener('submit', (event) => {
          event.preventDefault();
          const values = this.numbers(this.fence);
          const overlap = values.board === 125;
          const length = values.length * 1000;
          const count = overlap
            ? (length - values.spacing) / (values.board - values.spacing)
            : (length + values.spacing) / (values.board + values.spacing);
          const boards = Math.max(1, Math.ceil(count - 1e-10));
          this.put('[data-boards]', boards);
          this.put('[data-total-boards]', Math.ceil(boards * (1 + values.allowance / 100) - 1e-10));
          this.querySelector('[data-fence-result]').hidden = false;
        }, options);
        this.fence.addEventListener('input', () => { this.querySelector('[data-fence-result]').hidden = true; }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      numbers(form) { return Object.fromEntries([...new FormData(form)].map(([key, value]) => [key, Number(value)])); }
      put(selector, value, unit = '') {
        this.querySelector(selector).textContent = value.toLocaleString(document.documentElement.lang || 'en-GB', { maximumSignificantDigits: 7 }) + unit;
      }
    }
    customElements.define('tmg-project-tools', TMGProjectTools);
  }

  } catch(e) { console.error(e); }
})();
})();
